// TODO duped: watchlists.js
export const MARKET = 'MARKET'
export const COMPANY = 'COMPANY'

export default {
    MARKET,
    COMPANY,
}
